// Helper function to convert wind direction degrees to arrow emoji
/**
 * Get wind arrow and direction label from degrees
 * @param {number} degrees - Wind direction in degrees
 * @returns {string} Wind arrow and direction label
 */
export const getWindArrow = (degrees) => {
  if (!degrees) return '↑ N';
  const degree = parseInt(degrees) % 360;
  if (degree >= 337.5 || degree < 22.5) return '↑ N'; // N
  if (degree >= 22.5 && degree < 67.5) return '↗ NE'; // NE
  if (degree >= 67.5 && degree < 112.5) return '→ E'; // E
  if (degree >= 112.5 && degree < 157.5) return '↘ SE'; // SE
  if (degree >= 157.5 && degree < 202.5) return '↓ S'; // S
  if (degree >= 202.5 && degree < 247.5) return '↙ SW'; // SW
  if (degree >= 247.5 && degree < 292.5) return '← W'; // W
  if (degree >= 292.5 && degree < 337.5) return '↖ NW'; // NW
  return '↑ N';
};
